<template>
  <div v-if="displayGroups.length" :class="ns.b()">
    <span :class="ns.e('label')">
      <z-icon :class="ns.e('icon')"><Filter /></z-icon>
      {{ t('z.table.filterSummary') }}
    </span>
    <div :class="ns.e('content')">
      <template v-for="(group, groupIndex) in displayGroups" :key="group.id">
        <span v-if="groupIndex > 0" :class="ns.e('logic')">
          {{ t(`z.table.logic.${group.groupLogic}`) }}
        </span>
        <span
          v-if="group.conditions.length > 1"
          :class="[ns.e('bracket'), ns.is('open', true)]"
        >
          (
        </span>
        <template v-for="(cond, condIndex) in group.conditions" :key="cond.id">
          <span v-if="condIndex > 0" :class="ns.e('logic')">
            {{ t(`z.table.logic.${cond.logic}`) }}
          </span>
          <z-tag
            :class="ns.e('tag')"
            size="small"
            closable
            effect="plain"
            @close="removeCondition(group.id, cond.id)"
            @click="openFilterPanel"
          >
            <span :class="ns.e('field')">{{ cond.columnTitle }}</span>
            <span :class="ns.e('operator')">{{ cond.operatorLabel }}</span>
            <span v-if="cond.valueLabel" :class="ns.e('value')">{{ cond.valueLabel }}</span>
          </z-tag>
        </template>
        <span
          v-if="group.conditions.length > 1"
          :class="[ns.e('bracket'), ns.is('close', true)]"
        >
          )
        </span>
      </template>
    </div>
    <div :class="ns.e('actions')">
      <z-button link type="primary" :class="ns.e('edit')" @click="openFilterPanel">
        {{ t('z.table.filterEdit') }}
      </z-button>
      <z-button link type="danger" :class="ns.e('clear')" @click="clearAllFilter">
        {{ t('z.table.clearFilter') }}
      </z-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import ZTag from '@zoryn/components/tag'
import ZButton from '@zoryn/components/button'
import ZIcon from '@zoryn/components/icon'
import { Filter } from '@zoryn/icons'
import { useLocale, useLovCacheVersion, useNamespace } from '@zoryn/hooks'
import {
  buildFilterDisplayGroups,
  removeFilterConditionById,
} from '../filter/filter-display'
import type { DataGrid } from '../types'

const ns = useNamespace('grid-filter-summary')
const { t } = useLocale()
const $grid = inject('$grid') as DataGrid
const { reactData, internalData } = $grid
const lovCacheVersion = useLovCacheVersion()

const displayGroups = computed(() => {
  void lovCacheVersion.value
  return buildFilterDisplayGroups(reactData.filterGroups, internalData.titleList, t)
})

function removeCondition(groupId: string, conditionId: string) {
  reactData.filterGroups = removeFilterConditionById(
    reactData.filterGroups,
    groupId,
    conditionId
  )
  reactData.currentPage = 1
  void $grid.queryByExamplePage()
}

function openFilterPanel() {
  reactData.filterVisible = true
}

function clearAllFilter() {
  $grid.clearAllFilter?.()
}
</script>
